import { createFileRoute } from "@tanstack/react-router";

import { SignInPage } from "@/features/auth/sign-in-page";
import { optionalString } from "@/lib/search";

export interface SignInSearch {
  /** Where to go after signing in (a same-origin path); the gate writes it. */
  redirect_url?: string;
}

/** `/sign-in` and Clerk's sub-steps (`/sign-in/factor-one`, …) with path routing. */
export const Route = createFileRoute("/sign-in/$")({
  validateSearch: (raw: Record<string, unknown>): SignInSearch => ({
    redirect_url: optionalString(raw.redirect_url),
  }),
  component: SignInPage,
});
